'use client';

import { Radar01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Button } from '../../components/button';
import { SettingsRow } from '../settings/SettingsRow';

type SurfaceLinkProps =
  | {
      renderSurfaceLink: (surfaceName: string) => ReactNode;
      onOpenSurface?: never;
    }
  | { onOpenSurface: () => void; renderSurfaceLink?: never };

export type ApplicationSourceSurfaceSettingsRowProps = {
  surfaceName: string | undefined;
} & SurfaceLinkProps;

const LINK_BUTTON_STYLE = {
  variant: 'link',
  size: 'sm',
  p: 0,
  h: 'auto',
  minH: 0,
} as const;

export function ApplicationSourceSurfaceSettingsRow({
  surfaceName,
  renderSurfaceLink,
  onOpenSurface,
}: ApplicationSourceSurfaceSettingsRowProps) {
  const t = useTranslations('designSystem.applicationGeneral.sourceSurface');
  const resolvedSurfaceName = surfaceName ?? t('label');

  return (
    <SettingsRow
      label={t('label')}
      leadingIcon={<Radar01Icon size={16} />}
      tooltip={t('fromSurface', { surfaceName: resolvedSurfaceName })}
      value={
        renderSurfaceLink ? (
          <Button asChild {...LINK_BUTTON_STYLE}>
            {renderSurfaceLink(resolvedSurfaceName)}
          </Button>
        ) : (
          <Button {...LINK_BUTTON_STYLE} onClick={onOpenSurface}>
            {resolvedSurfaceName}
          </Button>
        )
      }
    />
  );
}
